export const GOOGLE_ANALYTICS_ID = process.env.NEXT_PUBLIC_GA_ID;

export const GOOGLE_SCRIPTS = {
  analytics: {
    src: `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`,
    config: `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GOOGLE_ANALYTICS_ID}');
    `,
  },
};
